// extracted by mini-css-extract-plugin
export default {"home-wrapper":"home_home-wrapper__fqHVJ"};